import { gql } from '@apollo/client';

export const CREATE_PORTFOLIO = gql`
  mutation CREATE_PORTFOLIO($data: CreatePortfolioDto!) {
    createPortfolio(data: $data) {
      id
      userId
      image
      title
      url
      description
      genres
      tags
      teamMembers
      videoUrl
      createdAt
    }
  }
`;
